/* app/providers/ToastProvider.jsx — стопка тостов bottom-right.
   API: useToast() → { show(message, tone, duration?) }.
   На mobile поднят над таб-баром (bottom: tab-bar+8) — баг #44.
   z-index: var(--z-toast). Авто-dismiss 4с. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Toast } from '../../components/ui/Toast.jsx';
import { getOverlayRoot } from '../../lib/overlay.jsx';

  const { createContext, useContext, useState, useCallback, useRef } = React;

  const ToastContext = createContext(null);
  let _id = 0;

  function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const timers = useRef({});

    const dismiss = useCallback((id) => {
      setToasts((list) => list.filter((t) => t.id !== id));
      if (timers.current[id]) { clearTimeout(timers.current[id]); delete timers.current[id]; }
    }, []);

    const show = useCallback((message, tone = 'muted', duration = 4000) => {
      const id = ++_id;
      setToasts((list) => [...list, { id, message, tone }]);
      if (duration > 0) timers.current[id] = setTimeout(() => dismiss(id), duration);
      return id;
    }, [dismiss]);

    const value = { show, dismiss };

    return (
      <ToastContext.Provider value={value}>
        {children}
        {ReactDOM.createPortal(
          <div className="toast-stack" role="region" aria-label="Уведомления">
            {toasts.map((t) => (
              <Toast key={t.id} message={t.message} tone={t.tone} onDismiss={() => dismiss(t.id)} />
            ))}
          </div>,
          getOverlayRoot()
        )}
      </ToastContext.Provider>
    );
  }

  const useToast = () => useContext(ToastContext);

export { ToastProvider };
export { useToast };
